import axios from "@/lib/axios";

class CampaignService {
  constructor() {
    this.api = axios;
  }

  async getCampaigns() {
    const { data } = await this.api.get("/campaigns");
    return data;
  }

  async getCampaign(id) {
    const { data } = await this.api.get(`/campaigns/${id}`);
    return data;
  }

  async createCampaign(payload) {
    const { data } = await this.api.post("/campaigns", payload);
    return data;
  }

  async updateCampaign(id, payload) {
    const { data } = await this.api.put(`/campaigns/${id}`, payload);
    return data;
  }

  async deleteCampaign(id) {
    const { data } = await this.api.post(`/campaigns/${id}/invalidate`);
    return data;
  }

  async validateCampaign(id) {
    const { data } = await this.api.post(`/campaigns/${id}/validate`);
    return data?.data;
  }

  async invalidateCampaign(id) {
    const { data } = await this.api.post(`/campaigns/${id}/invalidate`);
    return data?.data;
  }

  async getCampaignProducts(id) {
    const { data } = await this.api.get(`/campaigns/${id}/products`);
    return data;
  }

  async getValidCampaigns() {
    const { data } = await this.api.get("/campaigns/valid");
    return data;
  }

  async getApplications(query = {}) {
    const params = {};

    if (query?.status && query.status !== "ALL") {
      params.status = query.status;
    }

    if (query?.campaignId) {
      params.campaignId = query.campaignId;
    }

    const { data } = await this.api.get("/campaign-applications/filter", {
      params,
    });
    return data;
  }

  async getApplication(id) {
    const { data } = await this.api.get(`/campaign-applications/${id}`);
    return data;
  }

  async approveApplication(id, payload) {
    const { data } = await this.api.post(
      `/campaign-applications/${id}/review`,
      payload,
    );
    return data;
  }

  async rejectApplication(id, payload) {
    const { data } = await this.api.post(
      `/campaign-applications/${id}/review`,
      payload,
    );
    return data;
  }

  async processApplication(id) {
    const { data } = await this.api.post(
      `/campaign-applications/${id}/process`,
    );
    return data;
  }
}

export default new CampaignService();
